import React, { useEffect, useState } from 'react';
import "./ServicesSettingsItemDetail.scss"

import { useSelector, useDispatch } from 'react-redux';
import PostService from '../../../API/PostService';
import { useFetching } from '../../../hooks/useFetching';
import { setSettingsAction } from '../../../store/settingsReducer';
import { days } from '../../../helpers/datetime';
import { toggleArrayItem } from '../../../helpers/general';
import { createTimeSlots } from '../../../helpers/table';

const ServicesSettingsItemDetail = ({ element = null, closeHandler, isOpen = false }) => {
    const dispatch = useDispatch();
    const settings = useSelector(state => state.settings.settings)
    const services = useSelector(state => state.services.services)
    const clinic = useSelector(state => state.recordsTable.clinic)

    const [sevicesList, setSevicesList] = useState(null);
    const [open, setOpen] = useState(false);
    const [selectedDays, setSelectedDays] = useState([]);
    const [daysList, setDaysList] = useState([]);
    const [selectedServices, setSelectedServices] = useState([]);

    const [timeSlots, setTimeSlots] = useState(createTimeSlots());
    const [timeStart, setTimeStart] = useState(null);
    const [timeEnd, setTimeEnd] = useState(null);

    const [showResult, setShowResult] = useState(false);

    useEffect(() => {
        let daysSelected = [];
        if(element?.weekdays){
            daysSelected = element.weekdays.map((el) => Number(el));
        }
        setSelectedDays(daysSelected)
        let daysAr = createDaysArray(daysSelected)
        setDaysList(daysAr)

        if(element?.time_start_formated) setTimeStart(element.time_start_formated)
        if(element?.time_end_formated) setTimeEnd(element.time_end_formated)
    }, [element])

    useEffect(() => {
        let servicesSelected = [];
        if(element?.services_disabled){
            servicesSelected = element.services_disabled.map((el) => Number(el))
        }
        setSelectedServices(servicesSelected)
        if(services){
            let servAr = createServicesArray(servicesSelected)
            setSevicesList(servAr)
        }
    }, [element, services])

    useEffect(() => {
        setOpen(isOpen)
    }, [isOpen])

    const createServicesArray = (selected = []) => {
        const arServices = [];
        for(let i = 0; i < services.length; i++){
            let newElem = {};
            newElem['value'] = services[i];
            newElem['selected'] = selected.indexOf(Number(services[i]['id'])) === -1;
            arServices.push(newElem);
        }

        return arServices;
    }

    const createDaysArray = (selected = []) => {
        const arDays = [];
        for(let i = 0; i < days.length; i++){
            let newElem = {};
            newElem['value'] = days[i][1];
            newElem['selected'] = selected.indexOf(i === 0 ? 7 : i) !== -1;
            arDays.push(newElem);
        }

        return arDays;
    }

    const selectDay = (id) => {
        let newSelectedDays = toggleArrayItem(selectedDays, id)
        setSelectedDays(newSelectedDays)
        let daysAr = createDaysArray(newSelectedDays)
        setDaysList(daysAr)
    }

    const selectTime = (time) => {
        if(!timeStart){
            setTimeStart(time)
        } else {
            setTimeEnd(time)
        }
    }

    const selectService = (id) => {
        let newSelectedServices = toggleArrayItem(selectedServices, Number(id))
        setSelectedServices(newSelectedServices)
        let servAr = createServicesArray(newSelectedServices)
        setSevicesList(servAr)
    }

    const save = () => {
        fetchAddSetting(
            clinic,
            {
                time_start: timeStart,
                time_end: timeEnd,
                weekdays: selectedDays,
                services_disabled: selectedServices,
            }
        )
    }

    const update = () => {
        fetchUpdateSetting(
            element.id,
            {
                clinic: clinic,
                time_start: timeStart,
                time_end: timeEnd,
                weekdays: selectedDays,
                services_disabled: selectedServices,
            }
        )
    }

    const deleteSetting = () => {
        fetchDeleteSetting(element.id)
    }

    const [fetchAddSetting] = useFetching(async (clinicId, data) => {
		const response = await PostService.addSetting(clinicId, data)
		if (response.data.success && response.data.result !== false) {
			setShowResult(true)
            fetchSettings(clinicId)
		} else {
            setShowResult(false)
        }
	})

    const [fetchUpdateSetting] = useFetching(async (id, data) => {
		const response = await PostService.updateSetting(id, data)
		if (response.data.success && response.data.result !== false) {
			setShowResult(true)
            fetchSettings(clinic)
		} else {
            setShowResult(false)
        }
	})

    const [fetchDeleteSetting] = useFetching(async (id) => {
		const response = await PostService.deleteSetting(id)
		if (response.data.success && response.data.result !== false) {
            fetchSettings(clinic)
		}
	})

    const [fetchSettings] = useFetching(async (clinicId) => {
		const response = await PostService.getSettingsByClinic(clinicId)
		if (response.data.success && response.data.result !== false) {
			dispatch(setSettingsAction(response.data.result))
		}
	})

	return (
        <div className={"services-settings-list-item-detail g-hide-scrollbar" + (open ? ' open' : '')} key={selectedDays.join('-')}>
            <div className="services-settings-list-item-detail__goback" onClick={() => {
                if(closeHandler) closeHandler();
            }}>
                Назад
            </div>
            <div className="services-settings-list-item-detail__weekdays">
                {
                    daysList.map((el, index) => {
                        const itemId = index === 0 ? 7 : index;
                        return(
                            <div
                            className={'services-settings-list-item-detail__weekdays-btn' + (el.selected ? ' active' : '')}
                            key={el.value}
                            onClick={() => selectDay(itemId)}>{el.value}</div>
                        )
                    })
                }
            </div>
            <div className={"services-settings-list-item-detail__timeslots" + (timeStart && timeEnd ? ' period-selected' : '')}>
                {
                    timeSlots && timeSlots.map((el) => {
                        return(
                            <div className={
                                "services-settings-list-item-detail__timeslots-item"
                                + (el === timeStart || el === timeEnd ? ' active' : '')
                                + (el === timeStart ? ' active-start' : '')
                                + (el === timeEnd ? ' active-end' : '')
                            }
                            onClick={() => selectTime(el)}>
                                {el}
                            </div>
                        )
                    })
                }
            </div>
            <div className="services-settings-list-item-detail__services" key={selectedServices.join('-')}>
                {
                    sevicesList && sevicesList.map((el) => {
                        return(
                            <div className={"services-settings-list-item-detail__services-item" + (el.selected ? ' active' : '')}
                            onClick={() => selectService(el.value.id)} key={el.value.id}>
                                {el.value.short_title}
                                <div>{el.value.duration_formatted}</div>
                            </div>
                        )
                    })
                }
            </div>
            <div className="services-settings-list-item-detail__buttons">
                {
                    element ?
                    <>
                        <button className='g-button' onClick={update}>Сохранить</button>
                        <button className='g-button-link' onClick={deleteSetting}>Удалить настройку</button>
                    </>
                     :
                    <button className='g-button' onClick={save}>Сохранить</button>
                }
                
                {
                    showResult &&
                    <button className='g-button-secondary'>Настройки сохранены</button>
                }
            </div>
        </div>
	);
};

export default ServicesSettingsItemDetail;
